var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4251 16.5C10.2628 16.5 10.1049 16.4474 9.9751 16.35L6.9751 14.0625C6.88333 13.9919 6.80917 13.9009 6.75842 13.7968C6.70767 13.6927 6.68172 13.5783 6.6826 13.4625V11.01L3.0826 4.095C3.02331 3.98056 2.99451 3.85277 2.99899 3.72396C3.00346 3.59516 3.04105 3.46967 3.10814 3.35962C3.17523 3.24957 3.26954 3.15867 3.38199 3.09567C3.49443 3.03268 3.62121 2.99973 3.7501 3H14.2501C14.3803 3.00002 14.5082 3.03392 14.6213 3.09835C14.7343 3.16279 14.8287 3.25554 14.8951 3.3675C14.9609 3.48152 14.9956 3.61085 14.9956 3.7425C14.9956 3.87415 14.9609 4.00349 14.8951 4.1175L11.1451 11.025V15.75C11.1461 15.8898 11.108 16.027 11.0351 16.1463C10.9622 16.2656 10.8574 16.3621 10.7326 16.425C10.6366 16.4716 10.5318 16.4972 10.4251 16.5ZM8.1751 13.095L9.6751 14.2425V10.83C9.67463 10.7157 9.70028 10.6029 9.7501 10.5L12.9751 4.5H4.9801L8.0776 10.5C8.13229 10.6068 8.16058 10.7251 8.1601 10.845L8.1751 13.095Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWhite);
export default __webpack_public_path__ + "static/media/filterWhite.dfd72d08.svg";
export { ForwardRef as ReactComponent };